import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom';
import Content from '../../components/Content/Content';
import FormError from '../../components/FormError/FormError';
import Loader from '../../components/Loader/Loader';
import { getLegacyDonationButtonURL } from '../../endpoints';
import axiosInstance from '../../helpers/axiosInstance';
import { getErrorMessageOrDefault } from '../../helpers/errorMessageHelper/errorMessageHelper';

const LegacyDonation: FC = () => {
	const { id, key } = useParams<{ id: string; key: string }>();
	const { locale, formatMessage } = useIntl();
	const { push } = useHistory();
	const [buttonId, setButtonId] = useState<string>();
	const [error, setError] = useState<string>();

	useEffect(() => {
		axiosInstance
			.get<{ id: string }>(getLegacyDonationButtonURL(id, key))
			.then(({ data }) => {
				setButtonId(data.id);
			})
			.catch((e) => setError(formatMessage(getErrorMessageOrDefault(e.response?.data))));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (buttonId) push(`/${locale}/payment/donation/${buttonId}`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [buttonId]);

	return error ? (
		<Content name={error} showBadge={false}>
			<FormError />
		</Content>
	) : (
		<Loader />
	);
};

export default LegacyDonation;
